import { apiClient } from "./apiClient";
import {
  ITeamEmployeesResponse,
  ITeamEmployeeTable,
} from "../features/employeeTeams/interfaces/ITeamEmployeeInterface";

export async function getTeamEmployeesWithEvaluations(): Promise<ITeamEmployeesResponse> {
  const { data } = await apiClient.get<ITeamEmployeesResponse>(
    "/employeeteams/team-employees-evaluations"
  );
  return data;
}

export async function getTeamEmployees(
  segment: string = "my-team"
): Promise<ITeamEmployeeTable[]> {
  const baseUrl = "/employeeteams/";
  let url = "";
  if (segment === "my-team") {
    url = `${baseUrl}team-employees`;
  } else if (segment === "evaluated-by-team") {
    url = `${baseUrl}all-team-employees`;
  } else if (segment === "all-employees") {
    url = `${baseUrl}all-employees`;
  }
  const { data } = await apiClient.get<ITeamEmployeeTable[]>(url);
  return data;
}
